/* eslint-disable no-self-assign */
import { connect } from "react-redux";
import { Navigate } from "react-router";
import AuthLayout from "src/layouts/AuthLayout";

const FreeAuthRoute = ({ user, site, children }) => {
  if (localStorage.getItem("access_token") || user?._id) {
    if (window.location.href.includes("forgot-password")) {
      (() => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        window.location.href = window.location.href;
      })();

      return <></>;
    }

    return <Navigate to="/clients" />;
  }

  return <AuthLayout site={site}>{children}</AuthLayout>;
};

const mapStateToProps = (state) => {
  return {
    user: state?.auth?.user,
    site: state?.site,
  };
};

export default connect(mapStateToProps, null)(FreeAuthRoute);
